import reducer from './reducer'
import { combineReducers } from 'redux'

const combinedReducers = combineReducers({
  ui: reducer,
})

const rootReducer = (state, action) => {
  return combinedReducers(state, action)
}

export default rootReducer
